import { resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "cds-privacy-policy__close" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    id: "cds-privacy-policy",
    class: "cds-privacy-policy__dialog",
    scrim: "false",
    modelValue: _ctx.showPrivacyDialog,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showPrivacyDialog) = $event)),
    "max-width": "400px",
    style: _normalizeStyle(_ctx.cssVars)
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, { class: "cds-privacy-policy__card" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_v_btn, {
              class: "cds-privacy-policy__close-icon",
              density: "compact",
              icon: "mdi-close",
              "aria-label": "Close privacy policy dialog",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showPrivacyDialog = false)),
              onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.showPrivacyDialog = false), ["enter"]))
            })
          ]),
          _createVNode(_component_v_card_text, { class: "cds-privacy-policy__text" }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "default", {}, () => [
                _cache[3] || (_cache[3] = _createElementVNode("p", null, [
                  _createTextVNode(" Your anonymous response will be used by the "),
                  _createElementVNode("a", {
                    class: "cds-privacy-policy__link",
                    href: "https://www.cosmicds.cfa.harvard.edu/",
                    rel: "noopener noreferrer external",
                    target: "_blank"
                  }, "CosmicDS"),
                  _createTextVNode(" team to improve the educational experience. ")
                ], -1)),
                _cache[4] || (_cache[4] = _createElementVNode("p", { style: {"text-align":"right","margin-top":"1em","font-size":"0.9em"} }, [
                  _createElementVNode("a", {
                    href: "https://cfa.harvard.edu/privacy-statement",
                    rel: "noopener noreferrer external",
                    target: "_blank"
                  }, "Privacy Policy")
                ], -1))
              ])
            ]),
            _: 3
          })
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["modelValue", "style"]))
}